export default {
    "id": "Satellites-{entity.id}",
    "billboard": {
        "eyeOffset": {
            "cartesian": [
                0,
                0,
                0
            ]
        },
        "horizontalOrigin": "CENTER",
        "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABTCAYAAADjsjsAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3pJREFUeNrs3N1x2zAMAGBGl/eoE1SdIO4E1QjuBNUIHiEjeAR5gqob2BPUmaDKBvIECnGh71xZPyQFAgpE3OEhD5aiL+CfSOehbVsV4y42Orc6a52VzsbmQw8R8y5Knb9ufr7ozHWepz6YRLtRSIgnnUdTrRFzBqQTaMSchrQGjZh2kFagSYS0hpwETSKkV/SCJhHSO+5AkwiJB7q2STsmpOpO7NeEGQryGn+SCIkWaRIh8SKJkHj3ktxnwiu030T3OugsJFdmQQkpeWqU6fxHCSm5z9xRQ0qtzFR9bDc8UUJKrcwtB6TUyoS9mmdqSImVmXNBSsQsuCClNfNQ06GD7R/pcYEgWaf/axir8uB0XahM5sx1ljqbtj9qnXud2cR16hY3Stdn4UQEnKPjA77oTAeud+aE5MTMRypxKs4DoCkCaG3+YF7PxTEAwX7J35nXeDXToKZn9XP0mB6dzOu6cs4vRY2ZmUEFY4UyFxT2beCE215ZHMpa4gBUIQ8SPk0emvJupO/1TkrITRsmbEEr01cHe0bKZg79UagthLEmvzP3rkM/ICUmPMzXgNcfAiULSkyKG7GCUr3oyInu82xG8lQyJmWwgVJhNmsAldZnsvahlM38JL3JU2JW0vtQymZOsQXL2uQpKxMe4mUBo7yIyrwGPNAPRtSfobocjnnm1jQ5rthIaOa3zT1nBhW1AuIErSX1md0R/qjCncLoxptp5o2EykwZK/Ri+utPPTXKzJSoGZg8U4BafwF/3oI57HZuRbxV2xeN2TIJvjWDfUEAKSxOV1CBkkFiYmYTR1w4QEkhMTALjyMuFKDkkHMxS8a978VBQvqO5qXC27aFOeYOaWJPM2ojTtoxIa/xbWRl4nLchQ3SZ54ZAvI0scSzqVB2SFfMEJAQe4e1/GlgicgO6dLMQ0G+qf+PXdu+QtvevLQol/LW6JERUnlCnJdQhT6VGRIS4otiPBtE2WeGhjxIghyrzNCQEN+X2lwxK5MC8lUaZB8mBaTtdOhTN3MqyItiOvJHVZlUkGKr8lqZGN/LcRnBC6mYiccKJEKOYDYREncAYvtXDBIHoMKMshESARMqM0cGXRVkd9KOCbo6yL4VEAboKiGH1uZzQFcLOYTpC7pqyDFMV9DVQ05h2oJGSEvMKdAI2bMCsgl4bba/WcuXakE7g0uIdwEGAMSD6E2DhLMZAAAAAElFTkSuQmCC",
        "pixelOffset": {
            "cartesian2": [
                0,
                0
            ]
        },
        "scale": 0.5,
        "show": true,
        "verticalOrigin": "CENTER",
        "color": {
            "rgba": [33, 133, 208, 255]
        }
    },
    "label": {
        "fillColor": {
            "rgba": [
                255,
                255,
                255,
                255
            ]
        },
        "font": "11pt Lucida Console",
        "horizontalOrigin": "LEFT",
        "outlineColor": {
            "rgba": [
                0,
                0,
                0,
                255
            ]
        },
        "outlineWidth": 1,
        "pixelOffset": {
            "cartesian2": [
                16,
                0
            ]
        },
        "show": true,
        "style": "FILL_AND_OUTLINE",
        "text": "{entity.label}",
        "verticalOrigin": "CENTER"
    },
    "path": {
        "show": true,
        "width": 1.0,
        "material": {
            "solidColor": {
                "color": {
                    "rgba": [33, 133, 208, 255]
                }
            }
        },
        "resolution": 60.0,
        "leadTime": "{duration/2000}",
        "trailTime": "{duration/2000}"
    },
    "position": {
        "cartesian": "{position}",
        "epoch": "{new Date(startTime).toISOString()}",
        "referenceFrame": "INERTIAL",
        "interpolationAlgorithm": "LAGRANGE",
        "interpolationDegree": 5
    }
}